/**
 * 菜单
 */
export default [
    {
        label: 'service',
        // permission: 'wage_sys_menu',
        img: true,
        icon: 'icon-jigou',
        id:9,
        children: [
            {
                path: '/wage/payment',
                label: 'billLists',
                permission: 'set_paymentnotice_approve',
                icon: 'icon-yonghu',
                id: "9-1"
            },
            // {
            //     path: '/finance/invoice',
            //     label: '发票',
            //     permission: 'set_paymentnotice_approve',
            //     icon: 'icon-yonghu',
            //     id: "9-2"
            // },
        ]
    }
]
